import { SVGProps } from "react";

export const ExcelIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100"
      height="100"
      viewBox="0 0 48 48"
      {...props}
    >
      <path
        fill="#169154"
        d="M29,6H15.744C14.781,6,14,6.781,14,7.744v7.259h15V6z"
      ></path>
      <path
        fill="#18482a"
        d="M14,33.054v7.202C14,41.219,14.781,42,15.743,42H29v-8.946H14z"
      ></path>
      <path fill="#0c8045" d="M14 15.003H29V24.005000000000003H14z"></path>
      <path fill="#17472a" d="M14 24.005H29V33.055H14z"></path>
      <g>
        <path
          fill="#29c27f"
          d="M42.256,6H29v9.003h15V7.744C44,6.781,43.219,6,42.256,6z"
        ></path>
        <path
          fill="#27663f"
          d="M29,33.054V42h13.257C43.219,42,44,41.219,44,40.257v-7.202H29z"
        ></path>
        <path fill="#19ac65" d="M29 15.003H44V24.005000000000003H29z"></path>
        <path fill="#129652" d="M29 24.005H44V33.055H29z"></path>
      </g>
      <path
        fill="#0c7238"
        d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"
      ></path>
      <path
        fill="#fff"
        d="M9.807 19L12.193 19 14.129 22.754 16.175 19 18.404 19 15.333 24 18.474 29 16.123 29 14.013 25.07 11.912 29 9.526 29 12.719 23.982z"
      ></path>
    </svg>
  );
};
export const WordIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100"
      height="100"
      viewBox="0 0 48 48"
      {...props}
    >
      <linearGradient
        id="Q7XamDf1hnh~bz~vAO7C6a_pGHcje298xSl_gr1"
        x1="28"
        x2="28"
        y1="14.966"
        y2="6.45"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#42a3f2"></stop>
        <stop offset="1" stop-color="#42a4eb"></stop>
      </linearGradient>
      <path
        fill="url(#Q7XamDf1hnh~bz~vAO7C6a_pGHcje298xSl_gr1)"
        d="M42,6H14c-1.105,0-2,0.895-2,2v7.003h32V8C44,6.895,43.105,6,42,6z"
      ></path>
      <linearGradient
        id="Q7XamDf1hnh~bz~vAO7C6b_pGHcje298xSl_gr2"
        x1="28"
        x2="28"
        y1="42"
        y2="33.054"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#11408a"></stop>
        <stop offset="1" stop-color="#103f8f"></stop>
      </linearGradient>
      <path
        fill="url(#Q7XamDf1hnh~bz~vAO7C6b_pGHcje298xSl_gr2)"
        d="M12,33.054V40c0,1.105,0.895,2,2,2h28c1.105,0,2-0.895,2-2v-6.946H12z"
      ></path>
      <linearGradient
        id="Q7XamDf1hnh~bz~vAO7C6c_pGHcje298xSl_gr3"
        x1="28"
        x2="28"
        y1="-15.46"
        y2="-15.521"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#3079d6"></stop>
        <stop offset="1" stop-color="#297cd2"></stop>
      </linearGradient>
      <path
        fill="url(#Q7XamDf1hnh~bz~vAO7C6c_pGHcje298xSl_gr3)"
        d="M12,15.003h32v9.002H12V15.003z"
      ></path>
      <linearGradient
        id="Q7XamDf1hnh~bz~vAO7C6d_pGHcje298xSl_gr4"
        x1="12"
        x2="44"
        y1="28.53"
        y2="28.53"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#1d59b3"></stop>
        <stop offset="1" stop-color="#195bbc"></stop>
      </linearGradient>
      <path
        fill="url(#Q7XamDf1hnh~bz~vAO7C6d_pGHcje298xSl_gr4)"
        d="M12,24.005h32v9.05H12V24.005z"
      ></path>
      <path
        d="M22.319,13H12v24h10.319C24.352,37,26,35.352,26,33.319V16.681C26,14.648,24.352,13,22.319,13z"
        opacity=".05"
      ></path>
      <path
        d="M22.213,36H12V13.333h10.213c1.724,0,3.121,1.397,3.121,3.121v16.425	C25.333,34.603,23.936,36,22.213,36z"
        opacity=".07"
      ></path>
      <path
        d="M22.106,35H12V13.667h10.106c1.414,0,2.56,1.146,2.56,2.56V32.44C24.667,33.854,23.52,35,22.106,35z"
        opacity=".09"
      ></path>
      <linearGradient
        id="Q7XamDf1hnh~bz~vAO7C6e_pGHcje298xSl_gr5"
        x1="4.744"
        x2="23.494"
        y1="14.744"
        y2="33.493"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#256ac2"></stop>
        <stop offset="1" stop-color="#1247ad"></stop>
      </linearGradient>
      <path
        fill="url(#Q7XamDf1hnh~bz~vAO7C6e_pGHcje298xSl_gr5)"
        d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"
      ></path>
      <path
        fill="#fff"
        d="M18.403,19l-1.546,7.264L15.144,19h-2.187l-1.767,7.489L9.597,19H7.641l2.344,10h2.352l1.713-7.689	L15.764,29h2.251l2.344-10H18.403z"
      ></path>
    </svg>
  );
};
